<div class="p-6">
  <h2 class="text-xl font-semibold mb-4 text-white">{{ 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.TITLE' | translate
    }}</h2>

  <div class="mb-6">
    <p class="text-sm text-gray-300 mb-4">
      {{ 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.DESCRIPTION' | translate }}
    </p>

     <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.ANCIEN_COURRIEL' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="ancienCourrielInput">
      <mat-hint>{{ 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.HIT' | translate }}</mat-hint>
    </mat-form-field>

     <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.NOUVEAU_COURRIEL' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="nouveauCourrielInput">
      <mat-hint>{{ 'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.HIT' | translate }}</mat-hint>
    </mat-form-field>

    <div class="flex justify-end mr-5 space-x-4">
      <button type="submit" (click)="remplacerCourriel()" [disabled]="isLoading ||
       ancienCourrielInput.length === 0 || nouveauCourrielInput.length === 0
       || !validerEmail(ancienCourrielInput) || !validerEmail(nouveauCourrielInput) || (ancienCourrielInput == nouveauCourrielInput)"
          class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">{{
          'ADMINISTRATION_AVANCEE.REMPLACER_COURRIEL_EXISTANT.BUTTON_REMPLACER' | translate }}</button>
    </div>
  </div>
</div>
